import { ResultOf, gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query getPortfolioTransactions($id: String!) {
  Portfolio(
    id: $id
  ) {
    id
    transactions {
      symbol
      currencyISO
      exchangeCode
      transactionDate 
      units
      amount
      type
      holding {
        providerCompanyName
      }
    }
  }
}
`
);

export type Transaction = ResultOf<
  typeof QUERY
>['Portfolio']['transactions'][number];

export const usePortfolioTransactions = makeGqlQuery(QUERY, {
  gcTime: 0,
});
